// @flow
import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { ScaleLoader } from 'react-spinners'
import { isMobile } from '../../utils'
import { buildUrl } from '../../services/linking'

export default class ResetPassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      error: '',
      title: '',
      message: '',
      url: ''
    }
  }

  async componentDidMount () {
    const { username = '', resetCode = '' } = this.props.match.params
    this.setState({title: 'Cambiá la contraseña desde la app',
      message: 'Para garantizar la seguridad de tu cuenta sólo podés hacer el cambio de contraseña desde la app. Abrí el link del correo que recibiste desde el teléfono en el que tenés instalado Wink.',
      isLoading: false,
      url: buildUrl('reset-password/' + username + '/' + resetCode),
      isMobile
    })
  }

  render () {
    if (this.state.isLoading) {
      return (
        <Grid fluid>
          <Row center="sm">
            <Col xs={12} sm={12} md={12} lg={8}>
              <div className='mainContainer'>
                <Row center="xs">
                  <Col >
                    <div className='winkTopLogo'></div>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col>
                    <div className='tittle'>
                      <ScaleLoader
                        color={'#123abc'}
                        loading={this.state.isLoading}
                      />
                    </div>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col >
                    <div className='message'>Estamos procesando tus datos...</div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Grid>
      )
    }

    return (
      <Grid fluid>
        <Row center="sm">
          <Col xs={12} sm={12} md={12} lg={8}>
            <div className='mainContainer'>
              <Row center="xs">
                <Col >
                  <div className='winkTopLogo'></div>
                </Col>
              </Row>
              <Row center="xs">
                <Col >
                  <div className='tittle'>{this.state.title}</div>
                </Col>
              </Row>
              <Row center="xs">
                <Col >
                  <div className='message'>{this.state.message}</div>
                </Col>
              </Row>
              {!this.state.error && this.state.isMobile.any() && <Row center="xs">
                <Col >
                  <a href={this.state.url} className='btn-primary-outline'>ABRIR EN WINK</a>
                </Col>
              </Row>}
              <Row center="xs">
                <Col xs={12} md={12}>
                  <div className='warningMessage'>Sos parte de la familia Wink. Si necesitás cualquier cosa no dudes
                    contactarnos a través del chat de soporte del App. Nuestro <a href="#">Centro de Soporte</a> siempre está para ayudarte.</div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/index.js